import React from 'react'
import { Dialog, DialogContent, ClearIcon, Grid, styledComponent, Image } from '@hermes/web-components'

type GalleryLightboxProps = {
  isOpen: boolean
  onClose: () => void
  image: string
}

const StyledDialog = styledComponent(Dialog)(() => ({
  '& .MuiDialog-paper': {
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    margin: 0,
    padding: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  '& .MuiDialogContent-root': {
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column'
  },
  '& .MuiBox-root': {
    width: '100%',
    justifyContent: 'center',
    height: '100%',
    alignItems: 'center',
    display: 'flex'
  }
}))

const GalleryLightbox = ({ isOpen, onClose, image }: GalleryLightboxProps) => (
  <StyledDialog open={isOpen} onClose={onClose}>
    <DialogContent sx={{ px: 4, py: 3 }}>
      <Grid container justifyContent="flex-end" wrap="nowrap" sx={{ p: 4, position: 'absolute' }}>
        <ClearIcon onClick={onClose} sx={{ cursor: 'pointer', color: 'white' }} />
      </Grid>
      <Image height="100%" width="100%" src={image} alt={image} sx={{ objectFit: 'contain', p: 10 }} />
    </DialogContent>
  </StyledDialog>
)

export default GalleryLightbox
